import { lazyLoadOnRender } from '@ms/yammer-libs-lazy';
import type { ComponentType } from 'react';

const GroupAgentPreviewBannerIntegration = () =>
  import(/* webpackChunkName: "4-feat-group-agent-preview-banner" */ './GroupAgentPreviewBannerIntegration');

export const LoadableGroupAgentPreviewBanner: ComponentType<object> = lazyLoadOnRender({
  loader: GroupAgentPreviewBannerIntegration,
});
